import React from "react";
import { Box, Paper, Typography, Skeleton } from "@mui/material";

const KpiCard = ({
  icon: Icon,
  label,
  value,
  helper,
  color = "primary.main",
  loading = false,
}) => (
  <Paper
    sx={{
      p: 2,
      flex: 1,
      minWidth: 180,
      display: "flex",
      alignItems: "center",
      gap: 2,
      borderLeft: "4px solid",
      borderColor: color,
    }}
  >
    {Icon && (
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          bgcolor: "action.hover",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon sx={{ color, fontSize: 24 }} />
      </Box>
    )}
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
        {label}
      </Typography>
      {loading ? (
        <Skeleton width={60} height={32} />
      ) : (
        <Typography variant="h5" fontWeight={700}>
          {value ?? "—"}
        </Typography>
      )}
      {helper && (
        <Typography variant="caption" color="text.disabled" sx={{ display: "block" }}>
          {helper}
        </Typography>
      )}
    </Box>
  </Paper>
);

export default KpiCard;
